import baseValidator from '../baseValidator';
import { axiosObject } from '../setup';



function checkUser(payload) {
    return new Promise((resolve, reject) => {
        let uri = `${process.env.NX_PUBLIC_AUTH_API_URL}/users`;

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                if (errors.response.status === 422) {
                    reject(errors.response.data.errors);
                }

                reject(errors);
            });

    });
}

export { checkUser };
